const Property = require('../../entities/property');

const Business = require('../../entities/business');

const Location = require('../../entities/location');

module.exports = class AccessContext {
  constructor(property
  /*: ?Property | string*/
  , business
  /*: ?Business | string*/
  , location
  /*: ?Location | string*/
  ) {
    this.property = property;
    this.business = business;
    this.location = location;
  }

  clone(opt
  /*: ?Object*/
  = {})
  /*: AccessContext*/
  {
    const c = new AccessContext(this.property);
    c.business = this.business || opt.business || null;
    c.location = this.location || opt.location || null;
    return c;
  }

  serialize()
  /*: Object*/
  {
    const obj = {};
    obj.propertyId = this.property instanceof Property ? this.property.id : this.property;

    if (this.business) {
      obj.businessId = this.business instanceof Business ? this.business.id : this.business;
    }

    if (this.location) {
      obj.locationId = this.location instanceof Location ? this.location.id : this.location;
    }

    return obj;
  }

};